import { BaseDialog, FlexBox } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';

interface DuplicateOptionModalProps {
  isOpen: boolean;
  optionsNames: string[];
  onClose: (confirmed: boolean) => unknown;
}

const ConfirmDeleteModal: React.FC<DuplicateOptionModalProps> = ({
  isOpen,
  optionsNames,
  onClose,
}) => (
  <BaseDialog
    fullWidth={false}
    maxWidth={'md'}
    open={isOpen}
    onClose={onClose}
    title={'Remove options'}
    footerAction={{
      left: {
        children: 'Cancel',
        onClick: () => onClose(false),
        color: 'softGold',
      },
      right: {
        children: 'Delete options',
        onClick: () => onClose(true),
      },
    }}
  >
    <FlexBox
      alignItems={'flex-start'}
      justifyContent={'flex-start'}
      flexDirection={'column'}
      gap={0.5}
      p={2}
    >
      <Typography>
        Confirm you want to remove the following options from your proposal.
      </Typography>
      {optionsNames.map((name, index) => (
        <Typography key={index} component={'span'} sx={{ fontWeight: 800 }}>
          {name}
        </Typography>
      ))}
    </FlexBox>
  </BaseDialog>
);

export default ConfirmDeleteModal;
